import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'
import moment from 'moment'
import Chartkick, { LineChart } from 'react-chartkick'
import 'chart.js'

import { SearchConsoleIntervals } from 'utils/Enum'
import SearchConsoleUtils from 'utils/SearchConsoleUtils'

import IntervalSelector from './partials/IntervalSelector'
import './searchConsoleGraph.scss'

const periodValue = (period, metric) => {
  switch (metric) {
  case 'clicks':
  case 'impressions':
    return SearchConsoleUtils.metricSumForPeriod(period, metric)
  default:
    return SearchConsoleUtils.metricAverageForPeriod(period, metric)
  }      
}

const graphValue = (val, metric) => {
  switch (metric) {
  case 'ctr':
    return Math.round(val * 1000) / 10
  case 'position':
    return Math.round(-val)
  default:
    return Math.round(val)
  }
}

export default class SearchConsoleGraph extends React.Component {
  static propTypes = {
    data: React.PropTypes.array,
    metric: React.PropTypes.oneOf(['impressions', 'ctr', 'clicks', 'position']),
    interval: React.PropTypes.oneOf(['week', 'day']),
    onChangeInterval: React.PropTypes.func,
    placeholder: React.PropTypes.bool,
    compact: React.PropTypes.bool
  }

  generateSeries(metric, interval) {
    const { data } = this.props    
    const tickCount = SearchConsoleIntervals[interval].count

    let series = {}
    for (let i=0; i<tickCount; i++) {
      const period = SearchConsoleUtils.getIntervalPeriod(data, i, interval)
      if (period.length === 0) break

      const date = moment(period[period.length - 1].keys[0]).format('MMM DD')
      const value = periodValue(period, metric)

      series = { [date]: graphValue(value, metric), ...series }
    }

    return series
  }

  metricSuffix() {
    if (this.props.metric === 'ctr') return '%'
    return null
  }

  generateChartOptions() {
    const { metric } = this.props

    switch (metric) {
    case 'position':
      return {
        scales: {
          yAxes: [{
            ticks: {
              callback: function(value) {
                return -value;
              }
            }
          }]
        },
        tooltips: {
          callbacks: {
            label: function(tooltipItem, data) {
              return -(+tooltipItem.yLabel)
            }
          }
        }
      }
    default:
      return {}
    }
  }

  renderPlaceholder() {
    const dummySeries = SearchConsoleUtils.generateDummySeries()
    const heightProp = this.props.compact ? { height: '280px' } : null

    return (
      <div className="searchConsoleGraph">
        {!this.props.compact && (
          <div className="searchConsoleGraph__options">
            <div className="searchConsoleGraph__metrics medium-spacing--bottom">
              <IntervalSelector />
            </div>
          </div>
        )}
        <LineChart
          discrete
          curve={false}
          data={dummySeries}
          colors={['#5750C5']}
          thousands=","
          {...heightProp}
        />
      </div>
    )
  }

  render() {
    if (this.props.placeholder) return this.renderPlaceholder()

    const { interval, metric } = this.props
    const yAxisMin = metric === 'ctr' ? 0 : null
    const heightProp = this.props.compact ? { height: '280px' } : null

    return (
      <div className="searchConsoleGraph">
        {!this.props.compact && (
          <div className="searchConsoleGraph__options">
            <div className="searchConsoleGraph__metrics medium-spacing--bottom">
              <IntervalSelector value={interval} onChange={this.props.onChangeInterval} />
            </div>
          </div>
        )}
        <LineChart
          discrete
          min={yAxisMin}
          curve={false}
          data={this.generateSeries(metric, interval)}
          suffix={this.metricSuffix()}
          colors={['#5750C5']}
          thousands=","
          library={this.generateChartOptions()}
          download
          {...heightProp}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/components/search_console/SearchConsoleGraph.js